<div class="panel panel-default">
  <div class="panel-heading">
    {{ title }}
    <button
      type="button"
      class="btn btn-success"
      style="margin-left: 1%"
      (click)="downloadTemplate()">
      Descargar formato XLXS
    </button>
  </div>
  <div class="panel-body">
    <div class="container">
      <ng-container *ngIf="!fileLoaded">
        <form #formFile="ngForm">
          <div class="form-group">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <label class="lbl">Archivo</label>
                <sa-file-input
                  [acceptedFileTypes]="
                    '.xlsx, .xls, .csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                  "
                  (fileSelected)="onFileSelected($event)"
                  [fileExtension]="['xlsx']"
                  [multiple]="false">
                </sa-file-input>
              </div>
            </div>
          </div>
        </form>
        <app-loading-spinner *ngIf="loadRegisterSpinner"></app-loading-spinner>
        <button
          [disabled]="verifyFile(markListFile)"
          *ngIf="!loadRegisterSpinner"
          (click)="loadRegisterFile()"
          class="btn btn-primary"
          style="margin-top: 3%">
          Carga de Archivo
        </button>
      </ng-container>
      <ng-container *ngIf="fileLoaded">
        <div class="row">
          <div class="col-md-4 col-md-offset-4">
            <p class="text">El archivo se proceso completamente</p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div
  class="modal fade"
  bsModal
  #modalSuccess="bs-modal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">
          {{ modalTitle }}
        </h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="modalSuccess.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="messageModal == 'successLoadFile'">
          <ng-container *ngTemplateOutlet="successLoadFile"> </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  bsModal
  #modalFileLoad="bs-modal"
  tabindex="-2"
  role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-static-name" class="modal-title pull-left">
          Cargando archivo
        </h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="modalFileLoad.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <ng-container *ngTemplateOutlet="loadFile"> </ng-container>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    bsModal
    #modalLoadResult="bs-modal"
    role="dialog"
    aria-labelledby="dialog-static-name">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 id="dialog-static-name" class="modal-title pull-left">
            Resultado cargado
          </h4>
          <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="modalLoadResult.hide(); modalFileLoad.hide()">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <ng-container *ngTemplateOutlet="loadFileResult"> </ng-container>
        </div>
      </div>
    </div>
    <ng-template #successLoadFile>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-centered">
            <p class="text text-center">Archivo cargado!!</p>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #loadFile>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-centered">
            <p class="text text-center">
              Por favor espera, cargando archivo...
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-centered">
            <app-loading-spinner></app-loading-spinner>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #loadFileResult>
      <div class="container-fluid">
        <div class="panel">
          <div class="panel-body">
            <div class="row">
              <div class="col-md-2">
                <label class="label lbl-primary">Vew lineas: </label>
              </div>
              <div class="col-md-10">
                <p xclass="text">{{ loadResultData?.totalLineas }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <label class="label lbl-primary">Input label file: </label>
              </div>
              <div class="col-md-10">
                <a
                  href="{{ loadResultData?.urlFile }}"
                  target="_blank"
                  class="btn btn-success"
                  >Descargar</a
                >
              </div>
            </div>
            <div class="row">
              <div class="col-md-2">
                <label class="label lbl-primary">Estados: </label>
              </div>
              <div class="col-md-10">
                <div [ngSwitch]="loadResultData?.status">
                  <span *ngSwitchCase="'LOAD'" class="badge badge-success"
                    >Archivo cargado</span
                  >
                  <span *ngSwitchCase="'NOT_LOAD'" class="badge badge-danger"
                    >Archivo no cargado</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="label lbl-primary">{{ 'TEXT-RAZON' | i18n }}: </label>
          </div>
        </div>
        <div class="container-fluid">
          <div class="panel">
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <table
                      class="table table-striped table-hover"
                      *ngIf="loadResultData?.fileErrors">
                      <tr>
                        <th scope="col">Fila</th>
                        <th scope="col">Columna</th>
                        <th scope="col">Mensaje</th>
                      </tr>
                      <tr *ngFor="let item of loadResultData?.fileErrors">
                        <td>
                          <p class="text-error">{{ item.row + 1 }}</p>
                        </td>
                        <td>
                          <p class="text-error">{{ item.columnName }}</p>
                        </td>
                        <td>
                          <p class="text-error">{{ item.message }}</p>
                        </td>
                      </tr>
                    </table>
                    <table
                      class="table table-striped table-hover"
                      *ngIf="!loadResultData?.fileErrors?.length > 0">
                      <tr>
                        <th scope="col">Linea</th>
                        <th scope="col">Razon</th>
                      </tr>
                      <tr
                        *ngFor="
                          let item of loadResultData?.dataFail | keyvalue
                        ">
                        <td>{{ item.key }}</td>
                        <td>
                          <p class="text-error">{{ item.value }}</p>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
